import { render, staticRenderFns } from "./MuralVaga.vue?vue&type=template&id=bd96e728"
import script from "./MuralVaga.vue?vue&type=script&lang=js"
export * from "./MuralVaga.vue?vue&type=script&lang=js"
import style0 from "./MuralVaga.vue?vue&type=style&index=0&id=bd96e728&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports